import { render, staticRenderFns } from "./ClassEventsCard.vue?vue&type=template&id=d1f14da4"
import script from "./ClassEventsCard.vue?vue&type=script&lang=js"
export * from "./ClassEventsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports